import React, { useState, useEffect } from 'react'
import { supabase } from '../../supabase';
import Loading from '../../components/Loading';
import { useNavigate } from 'react-router-dom';
import { comparePassword, hashPassword } from '../../utils/hashedPassword';

const Account = () => {
    const [user, setUser] = useState(null);
    const [passwordMessage, setPasswordMessage] = useState('');
    const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);

    const fetchUser = async () => {
        const { data: dataUser, error: errorUser } = await supabase.auth.getUser();
        if (errorUser) {
            console.error('Erro ao buscar informações do usuário:', errorUser.message);
            return;
        }
        console.log(dataUser);
        
        const { data, error } = await supabase
            .from('users')
            .select('*')
            .eq('uuid', dataUser.user.id)
            .single();
        if (error) {
            console.error('Erro ao buscar informações do usuário:', error.message);
            return;
        }
        setUser(data);
    };

    useEffect(() => {
        fetchUser();
    }, []);

    const handleEditPassword = async (e) => {
        e.preventDefault();
        setPasswordMessage('');
        setIsUpdatingPassword(true);

        const formData = new FormData(e.target);
        const currentPassword = formData.get('currentPassword');
        const newPassword = formData.get('newPassword');

        if (!currentPassword || !newPassword) {
            setPasswordMessage('Preencha todos os campos');
            setIsUpdatingPassword(false);
            return;
        }

        if (newPassword.length < 6) {
            setPasswordMessage('A nova senha deve ter pelo menos 6 caracteres');
            setIsUpdatingPassword(false);
            return;
        }

        try {
            // Compare the entered current password with the stored hashed password
            const isValidPassword = await comparePassword(currentPassword, user.password);
            
            if (!isValidPassword) {
                setPasswordMessage('Senha atual incorreta');
                setIsUpdatingPassword(false);
                return;
            }

           

       
                const { error } = await supabase.auth.updateUser({
                    password: newPassword,
                  });

            if (error) {
                console.error('Erro ao atualizar senha:', error.message);
                setPasswordMessage('Erro ao atualizar senha. Tente novamente.');
            } else {
                setPasswordMessage('Senha alterada com sucesso!');
                // Clear the form
                e.target.reset();
                // Update local user data
                fetchUser();
            }
        } catch (error) {
            console.error('Erro ao processar senha:', error);
            setPasswordMessage('Erro interno. Tente novamente.');
        } finally {
            setIsUpdatingPassword(false);
        }
    }

    const handleEdit = (e) => {
        e.preventDefault();

        console.log(user);
    // Atualiza o usuário no Supabase (exemplo: atualizar nome)
    if (!user) return;

    const updateUser = async () => {
        const { error } = await supabase
            .from('users')
            .update({ name: user.name })
            .eq('uuid', user.uuid);

        if (error) {
            console.error('Erro ao atualizar usuário:', error.message);
        } else {
            // Opcional: feedback de sucesso
            fetchUser(); // Atualiza os dados locais
        }
    };

    updateUser();
    }
  return (
        <main className="p-8 w-full flex gap-4">
            <div className="flex flex-col gap-4 w-full">
            
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-2xl font-bold">
                    Minha Conta
                
                </h1>

            </div>

            <div className="flex flex-col gap-4">
                  
                <div>
                    <h2>Nome:</h2>
                    <input className="border border-gray-300 rounded-md p-2" type="text" value={user?.name} onChange={(e) => setUser({ ...user, name: e.target.value })} />
                </div>
                <div>
                    <h2>Email</h2>
                    <input className="border border-gray-300 rounded-md p-2" type="email" value={user?.email} disabled />
                </div>
                <div>
                    <h2>Plano:    <b>{user?.plan ? user.plan : 'Free'}</b></h2> 
                </div>

                <div>
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                        type="button"
                        onClick={handleEdit}
                    >
                        Salvar Alterações
                    </button>
                </div>
                </div>
            </div>

            <div className="flex flex-col gap-4 w-full">
            
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-2xl font-bold">
                    Alterar Senha
                
                </h1>

            </div>

            <div className="flex flex-col gap-4">
                  
                <div>
                    <form onSubmit={handleEditPassword}>
                    <h2>Senha Atual:</h2>
                    <input 
                        className="border border-gray-300 rounded-md p-2" 
                        type="password" 
                        name="currentPassword"
                        required
                    />
          
                        
                    <div >
                        <h2>Nova Senha:</h2>
                        <input 
                            className="border border-gray-300 rounded-md p-2" 
                            type="password" 
                            name="newPassword"
                            required
                            minLength={6}
                        />
                    </div>
                    
                    {passwordMessage && (
                        <div className={`mt-2 p-2 rounded ${passwordMessage.includes('sucesso') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {passwordMessage}
                        </div>
                    )}
                
                <div className='mt-2'>
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition disabled:opacity-50"
                        type="submit"
                        disabled={isUpdatingPassword}
                    >
                        {isUpdatingPassword ? 'Alterando...' : 'Alterar Senha'}
                    </button>
                    </div>
                    </form>
                </div>
                </div>
            </div>
            </main>
      
    )
}

export default Account